import { render, staticRenderFns } from "./KidsProductEdit.vue?vue&type=template&id=a41c098a&scoped=true&"
import script from "./KidsProductEdit.vue?vue&type=script&lang=js&"
export * from "./KidsProductEdit.vue?vue&type=script&lang=js&"
import style0 from "./KidsProductEdit.vue?vue&type=style&index=0&id=a41c098a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41c098a",
  null
  
)

export default component.exports